const isNumber = (id) => !Number.isNaN(Number(id));

export default isNumber;
